import helpers from '../helpers.js';

/**
 * @ngdoc service
 * @name BaseClass.BCErrorable
 * @description
 * Model extension to handle errors from validation
 */
export default angular.module('BaseClass.errorable',[])
    .factory('BCErrorable', function() {
        function Errorable() {
            var $errors = {};

            /**
         * [Instance] Add error to list
         *
         * @param {String} fieldName Which model attribute is fudging up
         * @param {String} errorMessage
         */
            helpers.privateVariable($errors, 'add', function(fieldName, errorMessage) {
                if (_.isUndefined($errors[fieldName]))
                    $errors[fieldName] = [];
                if (!_.includes($errors[fieldName], errorMessage)) {
                    $errors[fieldName].push(errorMessage);
                    $errors.flatlist.push(errorMessage);
                    $errors.count++;
                }
            });

            var flatlist = [];
            helpers.privateVariable(flatlist, 'rebuild', function() {
                var errors = _.flatten(_.values($errors));
                this.splice.apply(this, [0, this.length].concat(errors));
            });
            helpers.privateVariable($errors, 'flatlist', flatlist);

            /**
         * [Instance] Clear the errors
         *
         * @param {string[]} fieldName Optional, single or list of fieldnames to clear
         * @param {string} errorMessage Optional
         */
            helpers.privateVariable($errors, 'clear', function(fieldName, errorMessage) {
                if (!_.isUndefined(errorMessage))
                    clearErrorMessage(fieldName, errorMessage);
                else {
                    var toClear = [];

                    if (_.isArray(fieldName))
                        toClear = fieldName;
                    if (_.isString(fieldName))
                        toClear.push(fieldName);
                    if (_.isUndefined(fieldName))
                        toClear = _.keys($errors);

                    _.each(toClear, removeFieldOfErrors);
                    $errors.flatlist.splice(0);
                }
            });

            /**
         * [Instance] Count errors
         *
         * @param {string[]} fieldName Optional, can be single fieldName or array
         */
            helpers.privateVariable($errors, 'countFor', function(fieldName) {
                if (_.isUndefined(fieldName))
                    return $errors.count;
                return $errors[fieldName] ? $errors[fieldName].length : 0;
            });

            function removeFieldOfErrors(fieldName) {
                var count = _.get($errors,[fieldName, 'length'], 0);
                delete $errors[fieldName];
                $errors.count -= count;
                $errors.flatlist.rebuild();
            }

            function clearErrorMessage(fieldName, errorMessage) {
                if (_.includes($errors[fieldName], errorMessage)) {
                    _.pull($errors[fieldName], errorMessage);
                    $errors.count--;
                    if ($errors[fieldName].length === 0) delete $errors[fieldName];
                    $errors.flatlist.rebuild();
                }
            }


            /**
         * @ngdoc object
         * @name BaseClass.BCErrorable#$errors
         * @propertyOf BaseClass.BCErrorable
         * @description
         * Array of errors, sneakily containing some hidden functions. Each model instance receives an $errors array
         *
         * <pre>
         * modelInstance.$errors.add(fieldName, errorMessage);
         * modelInstance.$errors.clear();
         * modelInstance.$errors.countFor(fieldName);
         * </pre>
         */
            helpers.privateVariable($errors, 'count', 0);
            helpers.privateVariable(this, '__$errors', $errors);
        }

        return Errorable;
    }).name;
